export default "__VITE_ASSET__$Itlb_pL__"